export default [
  {
    key: "debtor_external_id",
    label: "Debtor External ID",
    type: "string",
    validators: [{ validate: "required" }],
  },
  {
    key: "email",
    label: "Email",
    type: "email",
    validators: [{ validate: "required" }],
  },
];
